"use client"

import { BatteryMedium } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BatteryMediumIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BatteryMediumIcon = component(Icon)({ as: BatteryMedium })
